import React, { useState, useEffect } from "react";
import { Avatar } from "antd";
import http from "../../../../../services/http";
import { UserOutlined } from "@ant-design/icons";

export function RenderAvatar({ idImagem }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!idImagem) return;
    const fetchImage = async () => {
      setLoading(true);
      const api = await http("file", `v1/eleicoes_cipa_candidatos_imagens/carregar/${idImagem}`);
      if (api.statusCode === 200) {
        const url = window.URL.createObjectURL(api.response.data);
        setData(url);
      }
      setLoading(false);
    };
    fetchImage();
  }, [idImagem]);

  if (loading || !data) {
    return <Avatar size={60} icon={<UserOutlined />} />;
  }

  return <Avatar size={60} src={data} />;
}
